import { useMutation } from '@tanstack/react-query';
import { authService } from 'pages/auth/authService';

export const useSendResetPwdEmailMutation = () => {
  return useMutation(authService.sendResetPwdEmail);
};
